<template>
  <div>
    <div class="text-h6 mb-2">Code promo</div>
    <div v-if="!inscription.code_reduction">
      <v-btn variant="tonal" size="small" color="darkblue" @click="openDialogCodeReduction()">J'ai un code de réduction
        ?</v-btn>
    </div>
    <div v-else>
      <div class="d-flex justify-start align-center gap p-2 my-2 cart_course_item">
        <div>
          <v-icon icon="mdi-ticket-percent" color="primary"></v-icon>
        </div>
        <div>
          <div class="text-body-1">
            Code <b>{{ inscription.code_reduction.nom }}</b><button @click="remove_code_reduction()"
              class="text-dark-red" style="position: relative; top: -1px"><v-icon
                icon="mdi-delete-outline"></v-icon></button>
          </div>
        </div>
        <div class="justify-self-end text-body font-weight-bold">
          <span v-if="inscription.code_reduction.cart.prix">{{ inscription.code_reduction.cart.prix }}€</span><span
            v-else>-</span>
        </div>
      </div>
    </div>
    <v-dialog v-model="showDialogCodeReduction" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <p>Si vous possédez un code de réduction, vous pouvez l'entrer ici. Il sera appliqué à cette inscription.</p>
          <v-row>
            <v-col>
              <v-text-field label="Code de réduction" v-model="code_reduction.nom" dense outlined></v-text-field>
              <v-btn color="dark-green" block @click="checkValidityCode()">Appliquer</v-btn>
              <v-alert variant="tonal" color="error" v-if="!code_valid" class="mt-2">Ce code de réduction n'est pas
                valide, a expiré ou son nombre d'utilisation est atteint</v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showDialogCodeReduction = false">Abandonner</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";

import Code_Reduction from "@/classes/Code_Reduction/Code_Reduction.class";
export default {
  props: ["item"],
  data() {
    return {
      showDialogCodeReduction: false,
      code_reduction: {},
      code_valid: true,
      inscription: {},
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  methods: {
    openDialogCodeReduction() {
      this.showDialogCodeReduction = true;
      this.code_reduction = new Code_Reduction();
      this.code_reduction.id_module = this.mainStore.module.id;
    },
    async checkValidityCode() {
      this.code_valid = true;
      await this.code_reduction.fetch_by_name();
      if (!this.code_reduction.id) {
        this.code_valid = false;
        return;
      }
      const nb_local_usage = this.bookingStore.get_nb_usage_code_reduction(this.code_reduction.id);
      const remaining_usage = this.code_reduction.is_remaining_usage(nb_local_usage);
      if (remaining_usage) {
        this.inscription.apply_code_reduction(this.code_reduction);
        this.bookingStore.compute_cart();
        this.showDialogCodeReduction = false;
        return;
      }
      this.code_valid = false;

    },
    async remove_code_reduction() {
      await this.inscription.remove_code_reduction();
      this.bookingStore.compute_cart();
    },
  },
  created() {
    this.inscription = this.item;
  },
};
</script>

<style lang="scss" scoped></style>